import { Box, Button, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import { useState } from "react";
import { useEffect } from "react";
import { makeGetRequestToUrl, makePostRequestToUrl } from "../commonFunc.jsx";
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import { Label } from "flowbite-react";
import starIcon from '../../assets/icons/starIcon.png';

const ReviewSuggestion = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const [userTypeFilter, setUserTypeFilter] = useState('1');
    const [rows, setRows] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [newSuggestion, setNewSuggestion] = useState({});
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [currentSuggestion, setCurrentSuggestion] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [ratingBlocks, setRatingBlocks] = useState([
        {
          id: Date.now(),
          minRating: 1,
          maxRating: '',
          suggestions: [],
          suggestionInput: ''
        }
    ]);

    const fetchReviewSuggestionsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/analytics/fetch_review_suggestions';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                user_type: userTypeFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    
    useEffect(() => {
        fetchReviewSuggestionsData();
    }, [userTypeFilter]);

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    }

    const handleOpenEditModal = () => {
        if (rows.length === 0) return;
        const fetchedSuggestions = rows[0].review_suggestions;

        const mappedBlocks = ratingRanges.map(({ min, max, ratingKey }) => ({
            id: Date.now() + ratingKey, // unique id per block
            minRating: min,
            maxRating: max,
            suggestions: fetchedSuggestions[ratingKey] || [],
            suggestionInput: ''
        }));

        setRatingBlocks(mappedBlocks);
        setOpenEditModal(true);
    }

    const handleClose = () => {
        setOpenAddModal(false);
        setOpenEditModal(false);
        if(rows.length==0){
            setRatingBlocks([
                {
                  id: Date.now(),
                  minRating: 1,
                  maxRating: '',
                  suggestions: [],
                  suggestionInput: ''
                }
              ]);
        }
    }

    const addSuggestion = (rating) => {
        const updatedRows = [...rows];
    
        updatedRows.forEach(row => {
            const suggestions = row.review_suggestions;
            if (!suggestions[rating]) {
                suggestions[rating] = [];
            }
    
            if (newSuggestion[rating] && newSuggestion[rating].trim() !== '') {
                suggestions[rating].push(newSuggestion[rating].trim());
            }
        });
    
        setRows(updatedRows);
        setNewSuggestion({ ...newSuggestion, [rating]: '' }); // Clear input
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        showSnackbar(false);
    };

    let previousMaxRating = 1;
    const ratingRanges = [];

    if (rows.length > 0) {
        const ratings = Object.keys(rows[0].review_suggestions)
        .map(Number)
        .sort((a, b) => a - b);

        ratings.forEach((rating, idx) => {
        const currentMinRating = previousMaxRating;
        // For last rating, max rating = 5 else current rating
        const currentMaxRating = idx === ratings.length - 1 ? 5 : rating;

        ratingRanges.push({
            min: currentMinRating,
            max: currentMaxRating,
            ratingKey: rating,
        });

        previousMaxRating = currentMaxRating;
        });
    }
      
    const handleAddRatingBlock = () => {
        const lastBlock = ratingBlocks[ratingBlocks.length - 1];
        const newMin = parseInt(lastBlock?.maxRating || lastBlock?.minRating);
      
        const newBlock = {
          id: Date.now(),
          minRating: newMin ? newMin : 1,
          maxRating: '',
          suggestions: [],
          suggestionInput: ''
        };
      
        setRatingBlocks(prev => [...prev, newBlock]);
    };

    const handleMaxRatingChange = (id, value) => {
        // console.log('Attempting to change maxRating:', id, value);
        const numValue = Number(value);
        
        // Find the current block's index to determine the next block
        const currentBlockIndex = ratingBlocks.findIndex(block => block.id === id);
        const nextBlockIndex = currentBlockIndex + 1;
        const hasNextBlock = nextBlockIndex < ratingBlocks.length;
        
        const updatedBlocks = ratingBlocks.map((block, index) => {
            if (block.id === id) {
                // Update the current block's maxRating
                return {
                    ...block,
                    maxRating: numValue
                };
            } else if (hasNextBlock && index === nextBlockIndex) {
                // Update the next block's minRating to match current block's maxRating + 1
                return {
                    ...block,
                    minRating: numValue
                };
            }
            return block;
        });
        
        console.log('Updated blocks:', updatedBlocks);
        setRatingBlocks(updatedBlocks);
    };

    const handleSuggestionInputChange = (id, value) => {
        setRatingBlocks(prev =>
          prev.map(block =>
            block.id === id ? { ...block, suggestionInput: value } : block
          )
        );
    };
      
    const handleAddSuggestion = (id) => {
        setRatingBlocks(prev =>
          prev.map(block => {
            if (block.id === id && block.suggestionInput.trim() !== '') {
              return {
                ...block,
                suggestions: [...block.suggestions, block.suggestionInput.trim()],
                suggestionInput: ''
              };
            }
            return block;
          })
        );
    };
    
    const handleRemoveSuggestion = (id, indexToRemove) => {
        setRatingBlocks(prev =>
          prev.map(block => {
            if (block.id === id) {
              return {
                ...block,
                suggestions: block.suggestions.filter((_, idx) => idx !== indexToRemove)
              };
            }
            return block;
          })
        );
    };

    const handleSubmit = async() => {
        const token = localStorage.getItem('token');
        const payload={};
        ratingBlocks.forEach(block => {
            if (block?.maxRating && block.suggestions.length > 0) {
              payload[block?.maxRating] = block.suggestions;
            }
        });
        const params = {
            token: token,
            user_type: userTypeFilter,
            review_suggestions: payload,
        }

        try {
            const url = operationsUrl + '/driver/add_update_review_suggestions';
            const response = await makePostRequestToUrl(url,params);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenAddModal(false);
                setOpenEditModal(false);
                fetchReviewSuggestionsData();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleRemoveRatingBlock = (id) => {
        setRatingBlocks((prev) => {
            // Remove the block
            const updated = prev.filter((block) => block.id !== id);
    
            // Sort by order of appearance (optional if already sorted)
            const sorted = [...updated];
    
            // Recalculate minRating for each block based on previous maxRating
            for (let i = 0; i < sorted.length; i++) {
                if (i === 0) {
                    sorted[i].minRating = 1;
                } else {
                    const prevBlock = sorted[i - 1];
                    const newMin = parseInt(prevBlock.maxRating || prevBlock.minRating);
                    sorted[i].minRating = isNaN(newMin) ? prevBlock.minRating : newMin;
                }
            }
    
            return sorted;
        });
    };
    
      
    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Review Suggestions
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '3%' }}>
                <Grid2 item>
                    <Select value={userTypeFilter} 
                        onChange={(e) => setUserTypeFilter(e.target.value)} displayEmpty
                        style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: userTypeFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select User Type</MenuItem>
                        <MenuItem value="1">Customer</MenuItem>
                        <MenuItem value="2">Driver</MenuItem>
                    </Select>
                </Grid2>
                <Grid2 item>
                    {rows.length==0 && 
                        <Button variant="contained" 
                        onClick={handleOpenAddModal} 
                        style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: '#000000',textTransform: 'none'}}>
                            Add Reviews
                        </Button>
                    }
                    {rows.length>0 && 
                        <Button variant="contained" 
                        onClick={handleOpenEditModal} 
                        style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: '#000000',textTransform: 'none'}}>
                            Edit Reviews
                        </Button>
                    }
                </Grid2>
            </Grid2>
            
            {ratingRanges.map(({ min, max, ratingKey }) => {
                const suggestions = rows[0].review_suggestions[ratingKey];
                return (
                    <Grid2 key={ratingKey} sx={{border: '1px solid #D1D5DB',borderRadius: '8px',padding: '16px',backgroundColor: '#fff',marginTop: '3%', paddingBottom:'0px'}}>
                        <Grid2 sx={{display:'flex', marginBottom:'2%'}}>
                            <Grid2 sx={{backgroundColor: '#F9F9F9',padding: '12px',borderRadius: '8px', border:'1px solid #d1d5db',display: 'flex',alignItems: 'center',gap: '8px'}}>
                                <Typography sx={{ fontWeight: 500 }}>Minimum Rating:</Typography>
                                <Box
                                    sx={{display: 'flex',alignItems: 'center',flexWrap: 'nowrap',minWidth: '110px'}}
                                >
                                    {[...Array(5)].map((_, index) => (
                                        <Box key={index} component="span" sx={{ marginRight: '4px' }}>
                                            {index < min ? (
                                                <img src={starIcon} alt="star" height="14px" width="14px"/>
                                            ) : 
                                            (
                                                <img src={starIcon} alt="empty-star" height="14px" width="14px" style={{ opacity: 0.2 }} />
                                            )}
                                        </Box>
                                    ))}
                                </Box>
                            </Grid2>
                            <Grid2 sx={{backgroundColor: '#F9F9F9',padding: '12px',borderRadius: '8px', marginLeft:'2%', border:'1px solid #d1d5db',display: 'flex',alignItems: 'center',gap: '8px'}}>
                                <Typography sx={{ fontWeight: 500 }}>Maximum Rating:</Typography>
                                <Box
                                    sx={{display: 'flex',alignItems: 'center',flexWrap: 'nowrap',minWidth: '110px'}}
                                >
                                    {[...Array(5)].map((_, index) => (
                                        <Box key={index} component="span" sx={{ marginRight: '4px' }}>
                                            {index < max ? (
                                                <img src={starIcon} alt="star" height="14px" width="14px"/>
                                            ) : 
                                            (
                                                <img src={starIcon} alt="empty-star" height="14px" width="14px" style={{ opacity: 0.2 }} />
                                            )}
                                        </Box>
                                    ))}
                                </Box>
                            </Grid2>
                        </Grid2>
                        <hr/>
                        
                        <Grid container spacing={2} sx={{ marginTop: '8px', marginBottom: '2%' }}>
                            {suggestions.slice(0, 6).map((sugg, i) => (  // show up to 6 if needed, adjust as required
                                <Grid item xs={12} sm={6} md={4} key={i} sx={{marginBottom: '1%'}}>
                                <Box
                                    sx={{
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    backgroundColor: '#f9f9f9',
                                    borderRadius: '6px',
                                    padding: '6px',
                                    border: '1px solid #d1d5db',
                                    height: '100%', // optional for consistent box height
                                    }}
                                >
                                    {sugg}
                                </Box>
                                </Grid>
                            ))}
                        </Grid>

                    </Grid2>
                );
            })}

            {(openAddModal || openEditModal) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Grid2
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                                    {openEditModal ? 'Edit Review Suggestion' : 'Add Review Suggestion'}
                                </Typography>

                                
                                {ratingBlocks.map((block, idx) => (
                                    <Grid2
                                        key={block.id}
                                        sx={{ marginTop: '2%', border: '1px solid #D1D5DB', borderRadius: '8px', padding: '2%', backgroundColor: '#f9f9f9' }}
                                    >
                                        
                                        <IconButton size="small" onClick={() => handleRemoveRatingBlock(block.id)}>
                                            <CloseIcon fontSize="small" sx={{color:'red', justifyContent:'right'}} />
                                        </IconButton>

                                        <Grid2 container spacing={2}>
                                            <Grid2 item xs={6}>
                                                <Label>Minimum Rating<span style={{ color: 'red' }}>*</span></Label>
                                                <TextField
                                                    sx={{ marginTop: '6px' }}
                                                    type="number"
                                                    fullWidth
                                                    value={block?.minRating}
                                                    disabled
                                                    InputProps={{ style: { backgroundColor: '#f1f1f1', height: '48px' } }}
                                                />
                                            </Grid2>

                                            <Grid2 item xs={6}>
                                                <Label>Maximum Rating<span style={{ color: 'red' }}>*</span></Label>
                                                <TextField
                                                    sx={{ marginTop: '6px' }}
                                                    type="number"
                                                    fullWidth
                                                    value={block?.maxRating || ''}
                                                    onChange={(e) => handleMaxRatingChange(block.id, e.target.value)}
                                                    InputProps={{ 
                                                        inputProps: { 
                                                            min: block?.minRating || 0, 
                                                            max: 5,
                                                            step: 0.1
                                                        }, 
                                                        style: { 
                                                            height: '48px', 
                                                            backgroundColor: '#fff' 
                                                        } 
                                                    }}
                                                />
                                            </Grid2>
                                        </Grid2>

                                        <Grid2 sx={{ marginTop: '2%' }}>
                                            <Label>Review Suggestions<span style={{ color: 'red' }}>*</span></Label>
                                            <Grid2 sx={{border: '1px solid #D1D5DB', padding: '8px', borderRadius: '8px', marginTop: '1%', backgroundColor: '#fff'}}>
                                                <ul style={{ marginTop: '16px', paddingLeft: '16px' }}>
                                                    {block.suggestions.map((sugg, index) => (
                                                    <li key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                                                        <Typography>{sugg}</Typography>
                                                        <IconButton size="small" onClick={() => handleRemoveSuggestion(block.id, index)}>
                                                        <CloseIcon fontSize="small" />
                                                        </IconButton>
                                                    </li>
                                                    ))}
                                                </ul>
                                                
                                                <Grid2 sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        placeholder="Enter Review Suggestion"
                                                        value={block.suggestionInput}
                                                        onChange={(e) => handleSuggestionInputChange(block.id, e.target.value)}
                                                        InputProps={{ style: { height: '48px', backgroundColor: '#fff', borderRadius: '8px' } }}
                                                    />
                                                    <Button
                                                        onClick={() => handleAddSuggestion(block.id)}
                                                        sx={{ height: '48px', border: '1px solid #000000', textTransform: 'none', backgroundColor:'#000', borderRadius:'8px', minWidth:'100px' }}
                                                    >
                                                        <Typography sx={{color:'#fff'}}>Add</Typography>
                                                    </Button>
                                                </Grid2>
                                            </Grid2>

                                        </Grid2>
                                    </Grid2>
                                ))}

                                <Button onClick={handleAddRatingBlock} fullWidth sx={{borderRadius: '8px',border: '1px solid #000000',textTransform: 'none',padding: '2%',marginTop: '4%', backgroundColor:'#f9f9f9'}}>
                                    <Typography sx={{ color: '#000' }}>Add Rating and Suggestions</Typography>
                                </Button>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'8%' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {openEditModal ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Grid2>

                        </div>
                    </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    );
};

export default ReviewSuggestion;
